module.exports = __webpack_public_path__ + "static/img/zhuanli.cdd5929.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/zhuanli.png
// module id = OjJI
// module chunks = 1